import Vue from "vue";
import VueI18n from "vue-i18n";
import { getCookie, getBrowserLanguage } from "@Common";
import url from 'url'; // 引入 Node.js 的 url 模块

Vue.use(VueI18n);
const allLanguage = [
  "de",
  "en",
  "es",
  "fr",
  "id",
  "it",
  "ja",
  "ko",
  "pt",
  "ru",
  "th",
  "tr",
  "vi",
  "tw",
  "zh"
];

function detectLocale({ route, req }: { [propName: string]: any }): string {

  let locale = route.query.language || getBrowserLanguage() || getCookie("language") || "en";

  if (process.server && req) {
    const acceptLanguage = req.headers['accept-language'];
    // 解析 URL 获取 query 参数
    const parsedUrl = url.parse(req.url, true);
    const languageQuery = parsedUrl.query.language;
    if (languageQuery) {
      locale = languageQuery;
    } else if (acceptLanguage) {
      const preferredLanguage = acceptLanguage.split(',')[0].toLowerCase();
      locale = preferredLanguage.split('-')[0];
    }
    console.log('服务端检测到的语言', locale);
  }

  return locale;
}

export default ({ app, store, route, req }: { [propName: string]: any }, inject: any) => {
  let locale = detectLocale({ route, req });

  let language = locale.toLowerCase();

  if (language.includes("zh-hant") || language.includes("zh-hk") || language.includes("mo") || language.includes("zh-tw")) {
    // 繁体中文
    language = "tw";
  } else if (language.includes("zh-hans") || language === "zh" || language === "zh-cn") {
    language = "zh";
  } else {
    language = language.split("-")[0].split("_")[0];
  }

  store.dispatch("SET_LOCAL", language);

  console.log("最后当前语言", language);
  app.i18n = new VueI18n({
    locale: language, // 通过cookie设置国际化（用户选择一次终身不切换）
    fallbackLocale: "en", // 默认国际化
    messages: allLanguage.reduce((acc, item) => {
      acc[item] = require(`~/assets/languages/${item}.json`);
      return acc;
    }, {} as { [propName: string]: any })
  });

  inject('pageLanguage', language); //在组件内通过 this.$pageLanguage 来获取
};